const phases = [
  'Gap Analysis / Pre Audit',
  'Training'
]

export default phases
